<template>
	<div class="col-12 ">
		<buttom class="btn btn-success check-btn text-sm" @click="confirmInfo()"
			v-if="form.organization_charts_id == 2 && form.approved != 1 && (authUser.organization_charts_id == 1 || authUser.organization_charts_id == 3)">
			<i class="fa-solid fa-check"></i> Aprobar información
		</buttom>
		<buttom class="btn btn-info message-btn text-sm" @click="messageUser()"
			v-if="form.organization_charts_id == 2 && (authUser.organization_charts_id == 1 || authUser.organization_charts_id == 3)">
			<i class="fa-regular fa-message"></i> Enviar mensaje
		</buttom>
		<div class="row">
			<div class="col-12">
				<div class="card card-outline card-navy">
					<div class="card-header">
						<h3 class="card-title">Usuario</h3>
					</div>
					<div class="card-body">
						<form @submit.prevent="triggerSave">
							<div class="row">
								<!-- <div class="col-12 text-center">
									<h3>Imagen de perfil</h3>
									<img class="img-fluid rounded" style="width: 200px;" :src="img_perfil" alt="">
								</div>
								<div class="col-12">
									<hr>
								</div> -->
								<div class="col-md-4">
									<div class="form-group">
										<label> Nombre </label>
										<input disabled type="text" v-model="form.name" class="form-control">
										<div v-if="errors && errors.name" class="text-danger">{{ errors.name[0] }}</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label> Apellidos </label>
										<input disabled type="text" v-model="form.last_name" class="form-control">
										<div v-if="errors && errors.last_name" class="text-danger">{{
											errors.last_name[0] }}
										</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label> Perfil </label>
										<select disabled v-model="form.organization_charts_id" class="form-control">
											<option value="null"> Sin Perfil </option>
											<option :value="profile.id" v-for="(profile, index) in profiles"
												:key="index">
												<span v-if="profile.profil">{{ profile.profil.name }}</span>
												<span v-if="profile.area">- {{ profile.area.name }}</span>
											</option>
										</select>
										<div v-if="errors && errors.organization_charts_id" class="text-danger">{{
											errors.organization_charts_id[0] }}</div>
									</div>
								</div>

								<div class="col-md-4">
									<div class="form-group">
										<label> Email </label>
										<input disabled type="mail" v-model="form.email" class="form-control">
										<div v-if="errors && errors.email" class="text-danger">{{ errors.email[0] }}
										</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label> Teléfono </label>
										<input disabled type="text" v-model="form.phone" class="form-control">
										<div v-if="errors && errors.phone" class="text-danger">{{ errors.phone[0] }}
										</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label> WhatsApp </label>
										<input disabled type="text" v-model="form.whathsapp" class="form-control">
										<div v-if="errors && errors.whathsapp" class="text-danger">{{
											errors.whathsapp[0] }}
										</div>
									</div>
								</div>

								<div class="col-md-4"
									v-if="form.organization_charts_id != 2 && form.organization_charts_id != 9 && form.organization_charts_id != 7">
									<div class="form-group">
										<label> Fecha de nacimiento </label>
										<date-picker disabled v-model="form.birthday" valueType="format"></date-picker>
										<div v-if="errors && errors.birthday" class="text-danger">
											{{ errors.birthday[0] }}
										</div>
									</div>
								</div>

								<div class="col-md-4"
									v-if="form.organization_charts_id != 2 && form.organization_charts_id != 9 && form.organization_charts_id != 7">
									<div class="form-group">
										<label> Fecha de ingreso </label>
										<date-picker disabled v-model="form.entry_date"
											valueType="format"></date-picker>
										<div v-if="errors && errors.entry_date" class="text-danger">
											{{ errors.entry_date[0] }}
										</div>
									</div>
								</div>

								<div class="col-md-4">
									<div class="form-group">
										<label> Jefe directo </label>
										<select disabled v-model="form.user_id" class="form-control">
											<option v-for="(user, index) in catalogue.users_profile" :value="user.id"
												:key="index">
												{{ user.name }} {{ user.last_name }}</option>
										</select>
										<div v-if="errors && errors.user_id" class="text-danger">
											{{ errors.user_id[0] }}
										</div>
									</div>
								</div>

								<!-- empleado -->
								<div class="col-12"
									v-if="authUser.organization_charts_id == 1 && form.organization_charts_id != 7">
									<div class="row">

										<div class="col-md-2 text-center">
											<div class="form-group">
												<label> Empleado </label>
												<input disabled type="checkbox" v-model="form.employee"
													class="form-control">
												<div v-if="errors && errors.employee" class="text-danger">{{
													errors.employee[0] }}
												</div>
											</div>
										</div>

										<div class="col-md-10" v-if="form.employee">
											<div class="form-group">
												<label> Empresa </label>
												<select disabled v-model="form.company_id" class="form-control">
													<option value=""> Sin empresa </option>
													<option v-for="(company, index) in catalogue.company_pays"
														:value="company.id" :key="index">
														{{ company.name }}</option>
												</select>
												<div v-if="errors && errors.company_id" class="text-danger">
													{{ errors.company_id[0] }}
												</div>
											</div>
										</div>

										<div class="col-md-12" v-if="form.employee">
											<div class="form-group">
												<label> Documento Infonavit </label>
												<div class="custom-file"
													:style="infonavit_document != '' ? 'width: 87%' : 'width: 100%'">
													<input disabled type="file" class="custom-file-input"
														:class="infonavit_document != '' ? 'pr-5' : ''" id="customFile"
														ref="file" @change="infonavit_file">
													<label class="custom-file-label text-left" for="customFile">{{
														infonavitDocumentName
													}}</label>
												</div>
												<a :href="infonavit_document" v-if="infonavit_document != ''"
													target="_blank"
													style="float: right; border-radius: 5px 0px 5px 0px;"
													class="btn btn-info">
													<i class="fa-regular fa-file-pdf"></i></a>
												<div v-if="errors && errors.infonavit_document" class="text-danger">
													{{ errors.infonavit_document[0] }}
												</div>
											</div>
										</div>

										<div class="col-md-6" v-if="form.employee">
											<div class="form-group">
												<label> Descuento Infonavit </label>
												<money disabled v-model="form.infonavit_discount" class="form-control">
												</money>
												<div v-if="errors && errors.infonavit_discount" class="text-danger">
													{{ errors.infonavit_discount[0] }}
												</div>
											</div>
										</div>

										<div class="col-md-6" v-if="form.employee">
											<div class="form-group">
												<label> Sueldo bruto </label>
												<money disabled v-model="form.salary" class="form-control"></money>
												<div v-if="errors && errors.salary" class="text-danger">
													{{ errors.salary[0] }}
												</div>
											</div>
										</div>

										<div class="col-md-6" v-if="form.employee">
											<div class="form-group">
												<label> Días de vacaciones al año </label>
												<input disabled type="number" v-model="form.paid_days"
													class="form-control">
												<div v-if="errors && errors.paid_days" class="text-danger">
													{{ errors.paid_days[0] }}
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- Arrendatario -->
								<div class="col-md-12" v-if="form.organization_charts_id == 7">
									<div class="row">
										<div class="col-md-4">
											<label> Código de Cliente </label>
											<input type="text" disabled v-model="form.customer_code"
												class="form-control">
											<div v-if="errors && errors.customer_code" class="text-danger">{{
												errors.customer_code[0] }}</div>
										</div>

										<div class="col-md-4">
											<label> Correo(s) de envió </label>
											<input type="text" disabled v-model="form.shipping_email"
												class="form-control">
											<div v-if="errors && errors.shipping_email" class="text-danger">{{
												errors.shipping_email[0] }}</div>
										</div>

									</div>
								</div>


								<!-- Proveedor -->
								<div class="col-md-12" v-if="form.organization_charts_id == 2">
									<div class="form-group">
										<label> Web </label>
										<input disabled type="text" v-model="form.web" class="form-control">
										<div v-if="errors && errors.web" class="text-danger">{{ errors.web[0] }}</div>
									</div>
								</div>

								<div class="col-12" v-if="form.organization_charts_id == 2">
									<label> Giro </label>
									<multiselect disabled v-model="form.business_type" tag-placeholder="Agregar giro"
										placeholder="Buscar o agregar una giro" label="name" track-by="id"
										:options="catalogue.business_type" :multiple="true" :taggable="true"
										@tag="addTag">
									</multiselect>
								</div>

								<div class="col-md-12 mt-2" v-if="form.organization_charts_id == 2">
									<div class="form-group">
										<label> Observaciones </label>
										<textarea disabled v-model="form.observations" class="form-control"></textarea>
										<div v-if="errors && errors.observations" class="text-danger">{{
											errors.observations[0] }}</div>
									</div>
								</div>

								<div class="col-md-12" v-if="form.organization_charts_id == 2">
									<div class="form-group">
										<label> Calificación </label>
										<star-rating :read-only="true" :star-size="'20'"
											v-model="form.qualification"></star-rating>
										<div v-if="errors && errors.qualification" class="text-danger">{{
											errors.qualification[0] }}</div>
									</div>
								</div>
								<div class="col-md-12" v-if="form.organization_charts_id == 2"
									v-can="'companies_users'">
									<hr>
									<label class="control-label">Empresas:</label>
									<div class="table-responsive">
										<table class="table table-bordered text-center text-sm">
											<thead>
												<tr>
													<th>ID</th>
													<th>Nombre</th>
													<th>R.F.C</th>
												</tr>
											</thead>
											<tbody v-if="form.companies">
												<tr v-for="(user, index) in form.companies" :key="index">
													<td>{{ user.id }}</td>
													<td>{{ user.name }}</td>
													<td>{{ user.rfc }}</td>
												</tr>
											</tbody>
											<tbody v-else>
												<tr>
													<td align="center" colspan="5">Sin resultados.</td>
												</tr>
											</tbody>
										</table>										
									</div>
								</div>
								<!-- Fin proveedor -->
								<!-- Socio -->
								<div class="col-md-12" v-if="form.organization_charts_id == 8"
									v-can="'companies_users'">
									<hr>
									<label class="control-label">Empresas:</label>
									<div class="table-responsive">
										<table class="table table-bordered text-center text-sm">
											<thead>
												<tr>
													<th>ID</th>
													<th>Nombre</th>
													<th>R.F.C</th>
													<th>Reparto</th>
												</tr>
											</thead>
											<tbody v-if="form.companies">
												<tr v-for="(user, index) in form.companies" :key="index">
													<td>{{ user.id }}</td>
													<td>{{ user.name }}</td>
													<td>{{ user.rfc }}</td>
													<td>{{ percentages['id'+user.id] ?? 0 }}%</td>
												</tr>
											</tbody>
											<tbody v-else>
												<tr>
													<td align="center" colspan="5">Sin resultados.</td>
												</tr>
											</tbody>
										</table>										
									</div>
								</div>


								<!-- Supervisor -->
								<div class="col-md-12" v-if="form.organization_charts_id == 5">
									<hr>
									<div class="row mb-3">
										<div class="col-md-8">
											<label class="mt-3 control-label">Propiedades:</label>
										</div>

										<div class="col-md-4 text-center">
											<label> Editar indivisos </label>
											<input type="checkbox" v-model="form.see_departments"
												class="form-control form-control-sm">
											<div v-if="errors && errors.see_departments" class="text-danger">{{
												errors.see_departments[0]
											}}
											</div>

										</div>
									</div>
									<div class="table-responsive">
										<table class="table table-bordered text-center text-sm">
											<thead>
												<tr>
													<th>Folio</th>
													<th>Folio Interno</th>
													<th>Nombre</th>
													<th>Dirección</th>
													<th>Residente</th>
													<th v-if="form.organization_charts_id == 5">Caja chica</th>
												</tr>
											</thead>
											<tbody v-if="buildings">
												<tr v-for="(build, index) in buildings.data" :key="index">
													<td>{{ build.folio }}</td>
													<td>{{ build.folio_int }}</td>
													<td>{{ build.name }}</td>
													<td>{{ build.address }}</td>
													<td>
														<input disabled type="checkbox"
															class="form-control form-control-sm" :value="build.id"
															v-model="form.buildings">
													</td>
													<td v-if="form.organization_charts_id == 5">
														<input disabled type="checkbox"
															class="form-control form-control-sm" :value="build.id"
															v-model="form.buildings_resident">
													</td>
												</tr>
											</tbody>
											<tbody v-else>
												<tr>
													<td align="center" colspan="5">Sin resultados.</td>
												</tr>
											</tbody>
										</table>
										<pagination v-model="page_bul" :records="buildings.total"
											:per-page="buildings.per_page" @paginate="listBuildings" />
									</div>
								</div>
								<!-- Fin supervisor -->

								<div class="col-md-12"
									v-if="form.organization_charts_id == 15 || form.organization_charts_id == 4 || form.organization_charts_id == 10 || form.organization_charts_id == 3">
									<hr>
									<label class="control-label">Empresas Nominas:</label>
									<div class="table-responsive">
										<table class="table table-bordered text-center text-sm">
											<thead>
												<tr>
													<th>ID</th>
													<th>Nombre</th>
													<th>R.F.C</th>
													<th>Opciones</th>
												</tr>
											</thead>
											<tbody v-if="companies">
												<tr v-for="(user, index) in companies.data" :key="index">
													<td>{{ user.id }}</td>
													<td>{{ user.name }}</td>
													<td>{{ user.rfc }}</td>
													<td>
														<input disabled type="checkbox"
															class="form-control form-control-sm" :value="user.id"
															v-model="form.companies">
													</td>
												</tr>
											</tbody>
											<tbody v-else>
												<tr>
													<td align="center" colspan="5">Sin resultados.</td>
												</tr>
											</tbody>
										</table>
										<pagination v-model="page" :records="companies.total"
											:per-page="companies.per_page" @paginate="listCompanies" />
									</div>
								</div>


								<div class="col-12">
									<hr>
								</div>
								<div class="col-md-12">
									<router-link to="/users" class="btn float-left btn-outline-warning">
										<i class="fas fa-undo-alt"></i>
										Regresar
									</router-link>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div class="col-12">
				<div class="card card-primary card-outline card-outline-tabs">
					<div class="card-header p-0 pt-3 border-bottom-0">
						<ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
							<li class="nav-item">
								<a class="nav-link active" id="custom-tabs-four-home-tab" data-toggle="pill"
									href="#custom-tabs-four-home" role="tab" aria-controls="custom-tabs-four-home"
									aria-selected="true">Datos de facturación</a>
							</li>
							<li class="nav-item" v-if="form.organization_charts_id != 7">
								<a class="nav-link" id="custom-tabs-four-home-tab" data-toggle="pill"
									href="#custom-tabs-four-home-two" role="tab"
									aria-controls="custom-tabs-four-home-two" aria-selected="true">Cuentas Bancarias</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" id="custom-tabs-four-profile-tab" data-toggle="pill"
									href="#custom-tabs-four-profile" role="tab" aria-controls="custom-tabs-four-profile"
									aria-selected="false">Contactos</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" id="custom-tabs-four-files-tab" data-toggle="pill"
									href="#custom-tabs-four-files" role="tab" aria-controls="custom-tabs-four-files"
									aria-selected="false">Archivos</a>
							</li>
						</ul>
					</div>
					<div class="card-body">
						<div class="tab-content" id="custom-tabs-four-tabContent">
							<div class="tab-pane fade show active" id="custom-tabs-four-home" role="tabpanel"
								aria-labelledby="custom-tabs-four-home-tab">
								<ListBillingProvider />
							</div>
							<div class="tab-pane fade" id="custom-tabs-four-home-two" role="tabpanel"
								aria-labelledby="custom-tabs-four-home-tab">
								<ListBankAccount />
							</div>
							<div class="tab-pane fade" id="custom-tabs-four-profile" role="tabpanel"
								aria-labelledby="custom-tabs-four-profile-tab">
								<ListContact />
							</div>

							<div class="tab-pane fade" id="custom-tabs-four-files" role="tabpanel"
								aria-labelledby="custom-tabs-four-files-tab">
								<FormFilesComponents :prop_edit="false" />
							</div>
						</div>
					</div>

				</div>
			</div>

		</div>
	</div>
</template>

<script>
import request from '@/services/request'
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect'
import { StarRating } from 'vue-rate-it';
import Catalogue from '@/services/catalogue';

import ListBankAccount from '@/components/bank_account_provider/ListBankAccoutProviderDisabledComponent.vue';
import ListContact from '@/components/contanct_provider/ListContanctProviderDisabledComponent.vue';
import ListBillingProvider from '@/components/billing_data_provider/ListBillingProviderDisabledComponent.vue'
import FormFilesComponents from '@/components/users/FormFilesComponents.vue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';


export default {
	name: "users-form",
	components: {
		Multiselect,
		StarRating,
		ListBankAccount,
		ListContact,
		ListBillingProvider,
		FormFilesComponents,
		DatePicker
	},
	data() {
		return {
			form: {
				id: '',
				name: '',
				last_name: '',
				img_perfil: '',
				phone: '',
				whathsapp: '',
				organization_charts_id: '',
				email: '',
				birthday: '',
				entry_date: '',
				admission_date: '',
				user_id: '',
				observations: '',
				web: '',
				qualification: '',
				type_id: '',
				companies: [],
				buildings: [],
				buildings_resident: [],
				business_type: [],
				customer_code: '',
				shipping_email: '',
				employee: false,
				company_id: '',
				infonavit_discount: '',
				salary: '',
				paid_days: 0,
				infonavit_document: '',
				see_departments: false,
			},
			page: 1,
			page_bul: 1,
			companies: {},
			percentages: [],
			buildings: {},
			infonavit_document: '',
			infonavitDocumentName: null,
			showUsers: false,
			area: '',
			profiles: [],
			img_perfil: require('@/assets/img/profile.png'),
			errors: {},
			action: '/admin/user',
			catalogue: new Catalogue(),
			option: {
				penColor: "rgb(0, 0, 0)",
				backgroundColor: "rgb(255,255,255)"
			},
		}
	},
	mounted() {
		this.getProfiles();
		this.listCompanies();
		this.listBuildings();
		this.catalogue.get_business_type();
		this.catalogue.get_provider_types();
		this.catalogue.get_users_profile(10000);
		this.catalogue.get_company_pays();
		let id = this.$route.params.id;
		if (id) {
			this.get_id(id);
		}
	},
	methods: {
		async addTag(newTag) {
			let _endpoint = '/business_type'
			try {
				let { data } = await request.post(_endpoint, { name: newTag })
				if (data) {
					this.catalogue.get_business_type();
					this.form.business_type.push(data);
				}
			} catch (error) {
				console.log(error);
			}
		},
		async listCompanies(page = 1) {
			let search = {};
			let _endpoint = '/companies';
			try {
				let { data } = await request.list(_endpoint, page, search)
				if (data) {
					console.log(data);
					this.companies = data;
				}
			} catch (error) {
				console.log(error);
			}
		},
		async listBuildings(page_bul = 1) {
			let search = {};
			let _endpoint = '/buildings';
			try {
				let { data } = await request.list(_endpoint, page_bul, search)
				if (data) {
					this.buildings = data;
				}
			} catch (error) {
				console.log(error);
			}
		},
		csv_file(event) {
			console.log(event.target.files[0].type);
			if (event.target.files[0].type == "image/png" ||
				event.target.files[0].type == "image/jpeg") {
				this.form.img_perfil = event.target.files[0];
				this.img_perfil = URL.createObjectURL(event.target.files[0]);
			} else {
				this.$swal({
					icon: 'error',
					title: 'Error tipo de archivo',
					text: 'Solo se puede cargar archivos PNG , JPGE',
				});
			}
		},
		infonavit_file(event) {
			if (event.target.files[0].type == "application/pdf") {
				this.form.infonavit_document = event.target.files[0];
				this.infonavitDocumentName = event.target.files[0].name;
			} else {
				this.$swal({
					icon: 'error',
					title: 'Error tipo de archivo',
					text: 'Solo se puede cargar archivos PDF',
				});
			}
		},
		messageUser() {
			let vm = this;
			this.$swal({
				title: 'Mensaje para el usuario',
				input: 'textarea',
				inputAttributes: {
					autocapitalize: 'off'
				},
				showCancelButton: true,
				confirmButtonText: 'Guardar',
				showLoaderOnConfirm: true,
				preConfirm: async (message) => {
					console.log(message);
					let form = {
						id: this.form.id,
						message: message,
					};
					let _endpoint = '/message_users';
					try {
						let { data } = await request.postMedia(_endpoint, form)
						if (data) {
							await vm.successNotification(data.message);
						}
					} catch (error) {
						vm.errors = {};
						if (error.response) {
							vm.errors = vm.errorNotification(error);
						}
					}
				},
				allowOutsideClick: () => !this.$swal.isLoading()
			}).then((result) => {
				if (result.isConfirmed) {
					console.log(result);
				}
			})

		},
		confirmInfo: function () {
			let tit = 'Información validada';
			let txt = 'Seguro que la información ya está validada.';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					let form = {
						'user_id': this.form.id,
						'status': 1
					};

					let _endpoint = '/approved_users';
					let { data } = await request.postMedia(_endpoint, form)
					if (data) {
						console.log(data);
						this.successNotification(data.message);
						this.form.approved = 1;
					}

				}
			});
		},
		async triggerSave() {

			const data_form = new FormData();
			data_form.append('id', this.form.id);
			data_form.append('name', this.form.name);
			data_form.append('last_name', this.form.last_name);
			data_form.append('email', this.form.email);
			data_form.append('phone', this.form.phone);
			data_form.append('organization_charts_id', this.form.organization_charts_id);
			data_form.append('img_perfil', this.form.img_perfil);
			data_form.append('whathsapp', this.form.whathsapp);
			data_form.append('birthday', this.form.birthday);
			data_form.append('entry_date', this.form.entry_date);
			data_form.append('admission_date', this.form.admission_date);
			data_form.append('user_id', this.form.user_id);
			data_form.append('web', this.form.web);
			data_form.append('companies', this.form.companies);
			data_form.append('observations', this.form.observations);
			data_form.append('qualification', this.form.qualification);
			data_form.append('type_id', this.form.type_id);
			data_form.append('business_type', this.form.business_type.map(a => a.id));

			data_form.append('infonavit_discount', this.form.infonavit_discount);
			data_form.append('salary', this.form.salary);
			data_form.append('infonavit_document', this.form.infonavit_document);

			let _endpoint = '/users';
			if (this.form.id != "") {
				data_form.append('_method', 'PUT');
				_endpoint = `/users/${this.form.id}`;
			}

			try {
				let { data } = await request.postMedia(_endpoint, data_form)
				if (data) {
					console.log(data);
					// this.users = data.data;
					this.successNotification(data.message);
					this.$router.push('/users');
				}
			} catch (error) {
				this.errors = {};
				if (error.response) {
					let info_error = await this.errorNotification(error);
					if (info_error == 'Logout') {
						this.$nextTick(() => {
							location.reload()
						})
					} else {
						this.errors = info_error;
					}
				}
			}
		},
		async get_id(id) {
			let _endpoint = `/users/${id}`;
			try {
				let { data } = await request.get(_endpoint)
				if (data) {

					this.form.id = id;
					this.form.name = data.name;
					this.form.last_name = data.last_name;
					this.form.img_perfil = data.img_perfil;
					this.form.phone = data.phone;
					this.form.whathsapp = data.whathsapp;
					this.form.email = data.email;
					this.form.organization_charts_id = data.organization_charts_id;
					this.form.birthday = data.birthday;
					this.form.entry_date = data.entry_date;
					this.form.admission_date = data.admission_date;
					this.form.user_id = data.user_id;
					this.form.web = data.web;
					this.form.business_type = data.business_types;
					this.form.observations = data.observations;
					this.form.qualification = data.qualification;
					this.form.type_id = data.type_id;

					this.form.approved = data.approved;
					if (data.profile_picture) {
						this.img_perfil = this.globalUrlFiles + data.profile_picture;
					}

					if (data.infonavit_document) {
						this.infonavit_document = this.globalUrlFiles + data.infonavit_document;
					}
					this.form.infonavit_discount = data.infonavit_discount;
					this.form.salary = data.salary;
					this.form.paid_days = data.paid_days;

					let companies = [], percentages=[];

					if(data.companies_partner){
						data.companies_partner.forEach(function (valor) {
							companies.push(valor);
							percentages['id'+valor.id]=parseFloat(valor.pivot.percentage)*100;
						});}
					else{
						data.companies.forEach(function (valor) {
							companies.push(valor);
						});
					}

					this.form.companies = companies;
					this.percentages = percentages;

					this.form.customer_code = data.customer_code;
					this.form.shipping_email = data.shipping_email;

					this.form.employee = data.employee;
					this.form.company_id = data.company_id;

					this.form.see_departments = data.see_departments == 1 ? true : false;

					let buildings = [];
					data.buildings.forEach(function (valor) {
						buildings.push(valor.id);
					});

					this.form.buildings = buildings;

					let buildings_resident = [];
					data.buildings_resident.forEach(function (valor) {
						buildings_resident.push(valor.id);
					});

					this.form.buildings_resident = buildings_resident;

				}
			} catch (error) {
				this.errors = {};
				if (error.response) {
					this.errors = await this.errorNotification(error)
				}
			}
		},
		async getProfiles() {
			let service = request;
			let _endpoint = '/catalogue/profiles';
			try {
				let { data } = await service.get(_endpoint)
				if (data) {
					this.profiles = data;
				}
			} catch (error) {
				this.errors = {};
				if (error.response) {
					this.errors = await this.errorNotification(error)
				}
			}
		},
		...mapActions({
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		})
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.pagination {
	margin-bottom: 0;
}

.mx-datepicker {
	width: 100%;
}

.fs-6 {
	font-size: 12px;
}

.custom-file-label::after {
	content: "Archivo";
}

.check-btn {
	position: fixed;
	z-index: 2;
	right: 15px;
	bottom: 60px;
}

.message-btn {
	position: fixed;
	z-index: 2;
	right: 15px;
	bottom: 20px;
}
</style>
